<template lang="html">
  <d-card class="card-small mb-4">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" lg="4">
          <h6 class="m-0">Dados cadastrais</h6>
        </d-col>
        <d-col cols="12" lg="8" class="text-right" v-if="product">
          <product-buttons :product="product"></product-buttons>
        </d-col>
      </d-row>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <product-form ref="productForm"/>
            <d-row>
              <d-col cols="12">
                <div class="control__button">
                  <d-button @click="save" class="btn-primary">Salvar</d-button>
                  <loader v-if="loading" :fullPage="false" class="ml-4"/>
                </div>
              </d-col>
            </d-row>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
    <confirmation-modal
      :cancel="close"
      :confirm="confirmation.deleteMethod"
      :title="confirmation.title"
      :message="confirmation.message"/>
  </d-card>
</template>

<script>
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import ProductForm from './ProductForm.vue';
import ProductDelete from './ProductDelete';
import ProductButtons from './ProductButtons.vue';
import {
  _SAVE_PRODUCT_SUCCESS_,
  _DELETE_PRODUCT_,
  _DELETE_PRODUCT_EQUIPMENT_,
} from './ProductModel';

export default {
  name: 'product-page',
  mixins: [ProductDelete],
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
  components: {
    Loader,
    ProductForm,
    ProductButtons,
    ConfirmationModal,
  },
  data() {
    return {
      loading: false,
      confirmation: {
        title: 'Confirme exclusão de produto',
        message: 'Tem certeza que deseja excluir esse produto?',
        deleteMethod: this.deleteRow,
      },
      selectedObject: null,
    };
  },
  computed: {},
  methods: {
    save() {
      this.$refs.productForm.save();
      Events.$on(_SAVE_PRODUCT_SUCCESS_, product => {
        this.$router.push(`/admin/agentes/${product.id}`);
      });
    },
  },
  mounted() {
    Events.$on('loading', loading => {
      this.loading = loading;
    });
    Events.$on(_DELETE_PRODUCT_, productId => {
      this.confirmation = {
        title: 'Confirme exclusão de produto',
        message: 'Tem certeza que deseja excluir este produto?',
        deleteMethod: this.deleteRow,
      };
      this.selectedObject = productId;
    });
    Events.$on(_DELETE_PRODUCT_EQUIPMENT_, equipmentId => {
      this.confirmation = {
        title: 'Confirme exclusão de equipamento',
        message: 'Tem certeza que deseja excluir este equipamento?',
        deleteMethod: this.deleteEquipment,
      };
      this.selectedObject = equipmentId;
    });
  },
};
</script>

<style lang="scss" scoped>
.control__button {
  display: flex;
  justify-content: flex-start;
}
</style>
